import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import api from '../../ApiService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { toast } from 'react-toastify';

export default class GpoGroupsEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            gpoGroupHospitals: [],
            gpoGroupName: '',
            filter: 'select',
            loadingHospitals: true,
            isDirty: false,
            isCancel: true
        };
    }

    componentDidMount = async () => {
        let gpoGroupHospitals = await api.getGpoGroupHospitals(this.props.gpoOptionId, this.props.gpoGroup.id);
        this.setState({
            gpoGroupHospitals,
            loadingHospitals: false,
            gpoGroupName: this.props.gpoGroup.name
        });
    }

    onClickSave = async () => {
        if (this.state.isNameDirty) {
            var gpoGroup = {
                id: this.props.gpoGroup.id,
                gpoOptionId: this.props.gpoOptionId,
                name: this.state.gpoGroupName
            };
            let success = await api.saveGpoGroups(gpoGroup);
            if (success) {
                toast.success(`GPO Group Name updated.`);
            }
        }

        if (this.state.isDirty) {
            let items = this.state.gpoGroupHospitals;
            items = items.filter(item => item.gpoGroupId === this.props.gpoGroup.id);
            let success = await api.saveGpoGroupHospitals(items);
            if (success) {
                toast.success(`GPO Groups updated.`);
            }
        }

        let gpoGroupHospitals = await api.getGpoGroupHospitals(this.props.gpoOptionId, this.props.gpoGroup.id);
        this.setState({
            gpoGroupHospitals,
            isNameDirty: false,
            isDirty: false
        });
    }

    handleChange = (e) => {
        if (e.target.defaultValue === e.target.value) {
            this.setState({
                isNameDirty: false
            });
            return;
        }
        this.setState({
            isNameDirty: true,
            gpoGroupName: e.target.value
        });
    }

    renderSaveCancel = (columnSpread) => {
        return (
            <Grid item xs={columnSpread} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.props.onClickCancel} disabled={!this.state.isCancel}>Cancel</Button>
                <Button variant='contained' color='primary' style={{ width: '80px' }} onClick={this.onClickSave} disabled={!this.state.isDirty}>Save</Button>
            </Grid>
        );
    }

    renderDeleteSaveCancel = ( columnSpread) => {
        return (
            <Grid item xs={columnSpread} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.props.onClickDelete} >Delete</Button>
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.props.onClickCancel} disabled={!this.state.isCancel}>Cancel</Button>
                <Button variant='contained' color='primary' style={{ width: '80px' }} onClick={this.onClickSave} disabled={!this.state.isDirty && !this.state.isNameDirty}>Save</Button>
            </Grid>
        );
    }

    onIsAssignedChange = (e, rowData) => {
        let gpoGroupHospitals = this.state.gpoGroupHospitals.slice();
        let index = gpoGroupHospitals.findIndex(x => x.idiVetUser === rowData.idiVetUser);
        if (e.target.checked) {
            gpoGroupHospitals[index].gpoGroupId = this.props.gpoGroup.id;
        }
        gpoGroupHospitals[index].isAssigned = e.target.checked;

        this.setState({
            isDirty: true,
            gpoGroupHospitals
        });
    }

    isAssignedTemplate = (rowData, props) => {
        return (
            <Checkbox
                checked={rowData.isAssigned}
                onChange={(e) => this.onIsAssignedChange(e, props.rowData)}
                value={`gpoGroupHospitals[${props.rowIndex}].isAssigned`}
                color="primary"
            />
        );
    }

    isActiveTemplate = (rowData, props) => {
        return (
            <Checkbox
                checked={rowData.isActive}
                value={`affiliateGroupHospitals[${props.rowIndex}].isActive`}
                color="primary"
            />
        );
    }

    renderGpoGroupHospitals() {
        if (this.state.loadingHospitals)
            return <em>Loading...</em>;
        return (
            <div>
                <DataTable value={this.state.gpoGroupHospitals} editable>
                    <Column field="name" header="Name" sortable style={{ width: '5%' }} />
                    <Column field="description" header="Description" sortable style={{ width: '15%' }} />
                    <Column field="amGroup" header="Area Manager Groups" sortable style={{ width: '20%' }} />
                    <Column field="dmGroup" header="District Manager Groups" sortable style={{ width: '20%' }} />
                    <Column field="isAssigned" header="Assign?" body={this.isAssignedTemplate} sortable style={{ textAlign: 'center', width: '5%' }} />
                    <Column field="isActive" header="Active?" body={this.isActiveTemplate} sortable style={{ textAlign: 'center', width: '5%' }} />
                </DataTable>
                <br />
            </div>
        );

    }

    renderDetailsTable() {
        if (this.props.gpoGroup) {
            return (
                <div>
                    <Grid container spacing={0} >
                        <Grid item xs={3} style={{ marginRight: "0" }}>
                            <TextField
                                label='GPOOption'
                                defaultValue={this.props.gpoOptionName}
                                disabled fullWidth inputProps={{ maxLength: "50" }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="GpoGroup Name"
                                defaultValue={this.props.gpoGroup.name}
                                onChange={this.handleChange}
                                readOnly fullWidth inputProps={{ maxLength: "50" }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            {this.renderDeleteSaveCancel(12)}
                        </Grid>
                    </Grid>
                    <br />
                </div>
            );
        }
    }

    render() {
        let renderDetailsTable = this.renderDetailsTable();
        let gpoGroupHospitals = this.renderGpoGroupHospitals();
        return (
            <div>
                GPO Groups Management
                <hr />
                {renderDetailsTable}
                <hr />
                <br />
                <br />
                {gpoGroupHospitals}
                <br />
                {this.renderSaveCancel(12)}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ManageGroups/GpoGroupsEditor.js